<template>
  <div>
    <div :style="{background:'red'}">
      <h3>WIP ,NOT READY TO BE TESTED</h3>
    </div>
  
    <h3 class="review-title">Reviews</h3>
    <div class="d-flex flex-row rating-container">
      <div class="d-flex flex-column rating-box">
        <div
          class="d-flex flex-row"
          :style="{ padding: '0px', gap: '8px', 'justify-content': 'center' }"
        >
          <div
            class="star-container"
            :style="{ background: getPrimaryColor() }"
          >
            <font-awesome-icon size="2x" class="star" :icon="['fas', 'star']" />
          </div>
          <p>3.6</p>
        </div>
        <p class="rating">Overall Rating</p>
      </div>
      <div class="divider"></div>
      <div class="d-flex flex-column rating-box">
        <p>18</p>
        <p class="rating">Reviews</p>
      </div>
    </div>

    <!-- <div v-if="loading" class="d-flex justify-content-center mt-3"> 
              <div class="spinner-border  spinner-class"></div>
            </div> -->
    <div v-if="reviewDataPhy && !loading" class="mt-3">
      <div
        v-for="(review, index) in reviewDataPhy"
        :key="index"
        :style="{ 'margin-bottom': '16px' }"
        class="shadow-class"
      >
        <ReviewPhyCard :reviewData="review" :index="index" />
      </div>
    </div>

    <div class="d-flex justify-content-center" v-if="(reviewDataPhy && reviewDataPhy.length > 0)">
      <a-pagination
        v-model="page_num"
        class="dovemed-custom-pagination"
        :total="5"
        show-less-items
        :pageSize="5"
        @change="handleChangePage"
      />
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../../repositories/RepositoryFactory";
const UserRepository = RepositoryFactory.get("user");
import ReviewPhyCard from "./view/ReviewPhyCard.vue";
export default {
  name: "DoctorReviews",
  components: {
    ReviewPhyCard
  },
  data() {
    return {
      reviews: {},
      page_num: 1,
      items: 10,
      ext_id: undefined,
      circle_id: undefined,
      reviewDataPhy: {},
      loading: false,
      profileData: {}
    };
  },
  created() {
    this.ext_id = this.authUser.id;
    this.circle_id = this.$route.params.circle_id;
    console.log(this.ext_id,this.circle_id, "circle id--->");
    this.getReviews();
  },
  methods: {
    getReviews() {
      this.loading = true;
      console.log(this.$route.params.ext_ref_id,this.$route.params.circle_id);
      UserRepository.getUserReviews(
        this.page_num,
        this.items,
        this.circle_id,
        this.ext_id
      ).then(res => {
        this.loading = false;
        console.log(res.data.data);
        this.reviewDataPhy = res.data.data;
      });
    },
    handleChangePage() {
      this.page_num +=1;
      document.body.scrollTop = 0;
      console.log("pagination",this.page_num);
      this.getReviews();
    }
  }
};
</script>

<style lang="scss" scoped>
.review-title {
  font-weight: 700;
  font-size: 32px;
  line-height: 42px;
  color: #0f1734;
}
.rating-container {
  align-items: center;
  padding: 0px;
  gap: 13px;
  width: 790px;
  height: 110px;
  background: #f1f5f9;

  .rating {
    font-weight: 700;
    font-size: 12px;
    line-height: 14px;
    text-align: center;
    color: #94a3b8;
  }

  .rating-box {
    padding: 16px 0px;
    width: 381.51px;
    height: 70px;
    background: #f1f5f9;
    align-items: center;
  }
}

.star-container {
  width: 24px;
  height: 24px;
  border-radius: 2px;

  .star {
    transform: scale(0.7);
    width: 24px;
    height: 24px;
    color: white;
    position: absolute;
  }
}

.divider {
  width: 1px;
  height: 78px;
  background: #cbd5e1;
}
</style>



// WEBPACK FOOTER //
// src/components/Users/Doctor/DoctorReviews.vue